import AdvancedSelect from '@/components/common/AdvancedSelect'
import DocumentIcon from '../../Documents/Laboratory/Flag'
import {
  mapActions,
  mapGetters
} from 'vuex'
import strings from '../../../strings'
import batchService from '@/api/batch'
import {
  BATCH_STATE_OPENED,
  BATCH_STATE_PRINTED,
  BATCH_SOURCE_SYSTEM_WS,
  BATCH_SOURCE_SYSTEM_AOL2
} from '@/enums'

const mixin = {
  data: () => ({
    batchDetails: {},
    batchSelected: {},
    samplesFromBatchSelected: {},
    options: strings.sortPrintBatches,
    batchCurrentIndex: 0,
    lastSortPrintSelected: strings.sortPrintBatches[0],
    BATCH_STATE_PRINTED: BATCH_STATE_PRINTED,
    BATCH_STATE_OPENED: BATCH_STATE_OPENED,
    BATCH_SOURCE_SYSTEM_WS: BATCH_SOURCE_SYSTEM_WS,
    BATCH_SOURCE_SYSTEM_AOL2: BATCH_SOURCE_SYSTEM_AOL2
  }),
  components: {
    'advanced-select': AdvancedSelect,
    'document-icon': DocumentIcon
  },
  methods: {
    ...mapActions([
      'setWaitingBatchesLoadingStatus',
      'printReceiptBatchSamples',
      'printAndTransmit',
      'batchGetBatches',
      'sortPrintBatchShowOff',
      'sortPrintBatchSetColumn',
      'batchSetSortToSamples',
      'batchSetCardStatus',
      'clearAllBatchesData',
      'webSocketPrintAndTransmit'
    ]),
    getSamplesByBatchId (batchId) {
      return batchService.getBatchSamples({
        batchId: batchId,
        docDelivered: this.$route.query.docDelivered
      })
    },
    ShowOffComboSortSamples (batchIndex) {
      this.batchCurrentIndex = batchIndex
      this.sortPrintBatchShowOff(batchIndex)
    }
  },
  computed: {
    ...mapGetters([
      'batchesUnprinted',
      'batchesPrinted',
      'batchesLoadingStatus',
      'currentBatchOpenIndex',
      'isBatchDetailsShowing',
      'batchesPrintingStatus',
      'profile',
      'hasBatchesUnprinted',
      'hasBatchesPrinted'
    ]),
    batchesUnprintedSortPrint: {
      get: function () {
        if (this.$route.name === 'Impressão de Etiquetas - Lotes') {
          return this.batchesUnprinted[this.batchCurrentIndex].printSortSelected
        } else {
          return this.batchSelected.printSortSelected
        }
      },
      set: function (option) {
        if (!option) {
          this.lastSortPrintSelected = option
        }
        if (this.$route.name === 'Impressão de Etiquetas - Lotes') {
          this.sortPrintBatchSetColumn({
            column: option || this.lastSortPrintSelected,
            index: this.batchCurrentIndex,
            Unprinted: true
          })
        } else {
          let temp = this.batch
          temp.printSortSelected = option
          this.$set(this.batch, temp)
        }
      }
    }
  },
  watch: {
    batchesPrintingStatus: function (newValue) {
      if (newValue === 'STATUS_INITIAL') {
        if (this.$route.name === 'Impressão de Etiquetas - Lotes') {
          this.clearAllBatchesData()
          this.batchGetBatches()
        } else {
          this.loadBatchDetailsData()
        }
      }
    },
    batchesLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          break
        case 'STATUS_SUCCESS':
          this.setWaitingBatchesLoadingStatus()
          break
        case 'STATUS_FAILED':
          break
        case 'STATUS_INITIAL':
          this.clearAllBatchesData()
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    samplesFromBatchSelected: function (newVal) {
      this.$emit('update:samplesFromBatchSelected', newVal)
    },
    batchCurrentIndex: function (newVal) {
      this.$emit('update:batchCurrentIndex', newVal)
    },
    batchSelected: function (newValue) {
      this.$emit('update:batchSelected', newValue)
    }
  }
}

export default mixin
